<template>
   <div>
    <SuperKidPublicHeader></SuperKidPublicHeader>
    <div class="ranking-container">
      <header class="ranking-header">
        <h1 class="ranking-title">Cohort Rankings</h1>
        <p class="ranking-subtitle">Real-time performance rankings, aggregating platform points and social media engagement.</p>



        <div class="filter-controls">
            <div class="filter-group">
            <label for="cohort-filter">Category</label>
            <div class="select-wrapper">
                <select id="cohort-filter" v-model="category_id" class="filter-select">
                <!-- <option value="all">All Cohorts</option> -->
                <option :value="item.category_id" v-for="item in cohortCategories" :key="item.id">{{ item.name }}</option>
                </select>
            </div>
            </div>

            <div class="filter-group">
            <label for="category-filter">Cohort</label>
            <div class="select-wrapper">
                <select id="category-filter" v-model="cohort_id" class="filter-select">
                    <option value="" selected>Select Cohort</option>
                    <option :value="item.cohort_id" v-for="item in actualCohort" :key="item.id">{{ item.name }}</option>
                </select>
            </div>
            </div>
        </div>
      </header>

      <div v-if="loading">
        <PageLoader></PageLoader>
      </div>
  
      <div class="table-wrapper">
        <table class="responsive-table">
          <thead>
            <tr>
              <th class="col-rank">S/N</th>
              <th class="col-rank">Rank</th>
              <th class="col-user">Name</th>
              <th class="col-points text-right">Platform Points</th>
              <th class="col-social text-right">Social Points</th>
              <th class="col-total text-right">Total Points</th>
            </tr>
          </thead>
          <tbody>
            <!-- :key="user.kid_id"  -->
            <tr 
              v-for="(user, index) in cohortsRankings" 
              :key="index"
              :class="['row-rank-' + user.rank]"
            >
              <!-- Rank Column -->
              <td class="col-rank" data-label="S/N">
                <span class="rank-badge">{{ index + 1 }}</span>
              </td>

              <td class="col-rank" data-label="Rank">
                <span class="rank-badge">{{ user.rank }}</span>
              </td>
              
              <!-- User Name Column -->
              <td class="col-user" data-label="User">
                <span class="user-name">{{ user.kid_name }}</span>
              </td>
              
              <!-- Platform Points Column -->
              <td class="col-points text-right" data-label="Platform Points">
                <span class="numeric-val">{{ formatNumber(user.sum_app) }}</span>
              </td>
              
              <!-- Social Points Column -->
              <td class="col-social text-right" data-label="Social Points">
                <span class="numeric-val">{{ formatNumber(user.sum_social_media) }}</span>
              </td>
              
              <!-- Total Points Column -->
              <td class="col-total text-right highlight-cell" data-label="Total Points">
                <span class="numeric-val total-val">{{ formatNumber(user.total_points) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="cohortsRankings.length != 0 || (queryType == 'default' || queryType == 'challenge')">
                <!-- @page-changed="handlePageUpdate" -->
                <!-- :on-page-click="handlePageUpdate" -->
            <PaginationNew
                :current-page="page"
                :total-items="totalcount"
                :items-per-page="limit"
                @page-changed="handlePageUpdate"
                />
                
        </div>
    </div>
   </div>
  </template>
  
  <script>
    import { Service } from "../../store/service";
    const Api = new Service();
    import PageLoader from "../../components/PageLoader.vue";
    import EmptyState from "../../components/EmptyState.vue";
    import SubmissionComponent from "./SubmissionComponent";
    import SuperKidPublicHeader from "../../views/SuperKidPublicHeader.vue";
    import PaginationNew from "../../components/PaginationNew.vue";
  export default {
    name: 'CohortRanking',
    components: {
        // Header
        PageLoader,
        EmptyState,
        SuperKidPublicHeader,
        PaginationNew
    },
    data() {
      return {
        loading: false,
        category_id: "7",
        cohort_id: "",
        cohortCategories: [],
        actualCohort: [],
        page: 1,
        limit: 50,
        totalcount: 0,

        activePage: 1,
        perPageLimit: 30,
        serverTotalCount: 150,
        queryType: "default",
        cohortsRankings: [
        //   { id: 1, name: 'Alex Rivera', platformPoints: 12450, socialPoints: 8900 },
        //   { id: 2, name: 'Samantha Vance', platformPoints: 14200, socialPoints: 6100 },
        //   { id: 3, name: 'Marcus Chen', platformPoints: 9800, socialPoints: 11500 },
        //   { id: 4, name: 'Amara Okafor', platformPoints: 11100, socialPoints: 9300 },
        //   { id: 5, name: 'Liam Davies', platformPoints: 8500, socialPoints: 4200 }
        ]
      };
    },
    watch: {
    
        category_id(newValue, oldValue) { 
            this.loading = true;
            if (newValue) {
                this.fetchCohortRankings();
                // this.onLoad = true;

            }
        },
        cohort_id(newValue, oldValue) { 
            this.loading = true;
            if (newValue) {
                this.fetchCohortRankings();
            }
        },
    },
    // computed: {
    //   rankedCohorts() {
    //     return this.cohortsRankings
    //       .map(user => ({
    //         ...user,
    //         totalPoints: user.sum_app + user.sum_social_media
    //       }))
    //       .sort((a, b) => b.totalPoints - a.totalPoints)
    //       .map((user, index) => ({
    //         ...user,
    //         rank: index + 1
    //       }));
    //   }
    // },
    async mounted() {
        this.fetchFilterParameters();
        this.fetchCohortRankings();
    },
    methods: {
        handlePageUpdate(newPageNumber) {
            this.page = newPageNumber;
            this.fetchCohortRankings();
            // console.log("Page number", newPageNumber, this.page)
            // this.activePage = newPageNumber;
            // if (this.queryType == 'default') {
            //     this.fetchChallengesPostingList();
            // }
            // if (this.queryType == 'challenge') {
            //     this.fetchPostingListByChallengeId()
            // }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        // Trigger your backend API endpoint or fetch function here:
        // this.fetchNewDataPage(newPageNumber);
        },
        async fetchFilterParameters() {
            try {
                await Api.getRequest('get-cohort-leaderboard-parameters').then(res => {
                    // console.log("Paramters", res)
                    if (res.data.success) {
                        this.cohortCategories = res.data.categories,
                        this.actualCohort =  res.data.cohorts
                    }
                    
                }).catch(err => {
                    console.log("error", err);
                })
            } finally {
                // conosl.log("closded")
            }
        },
        async fetchCohortRankings() {
            this.loading = true;
            this.queryType = 'challenge';
            try {
                await Api.getRequest(`get-cohort-leaderboard?page=${this.page}&per_page=${this.limit}&category_id=${this.category_id}&cohort_id=${this.cohort_id}`).then(res => {
                    // console.log("Rankings", res)
                    this.loading = false;
                    if (res.data.success) {
                        this.cohortsRankings = res.data.data;
                        this.page = Number(res.data.page);
                        this.totalcount = Number(res.data.total_number_of_entries);
                    }
                }).catch(err => {
                    console.log("error", err);
                    this.loading = false;
                })
            } finally {
                // conosl.log("closded")
            }
        },
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        }
    }
  };

  </script>
  
  <style lang="scss" scoped>
  // --- Variables & Theming ---
  $bg-main: #f8fafc;
  $bg-card: #ffffff;
  $border-color: #e2e8f0;
  $text-primary: #0f172a;
  $text-secondary: #64748b;
  $primary-brand: #4f46e5;
  $primary-brand-light: #f5f3ff;
  
  // Podiums colors
  $gold: #d97706; $gold-bg: #fef3c7;
  $silver: #475569; $silver-bg: #f1f5f9;
  $bronze: #b45309; $bronze-bg: #ffedd5;
  
  // Breakpoints
  $breakpoint-md: 768px;
  
  // --- Base Container Styles ---
  .ranking-container {
    min-height: 100vh;
    background-color: $bg-main;
    padding: 2.5rem 1.5rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    color: $text-primary;
  }
  
  .ranking-header {
    max-width: 1000px;
    margin: 0 auto 2rem auto;
    
    .ranking-title {
      font-size: 1.875rem;
      font-weight: 800;
      letter-spacing: -0.025em;
      margin-bottom: 0.5rem;
    }
    
    .ranking-subtitle {
      font-size: 0.95rem;
      color: $text-secondary;
    }
  }

  .filter-controls {
  display: flex;
  gap: 1rem;
  width: 100%;

  @media (min-width: $breakpoint-md) {
    width: auto;
  }

  .filter-group {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    flex: 1;

    @media (min-width: $breakpoint-md) {
      flex: none;
      width: 180px;
    }

    label {
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: $text-secondary;
    }
  }

  .select-wrapper {
    position: relative;
    width: 100%;

    // Subtle down-arrow graphic treatment inside native select structures
    &::after {
      content: "↓";
      font-size: 0.8rem;
      color: $text-secondary;
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }
  }

  .filter-select {
    width: 100%;
    appearance: none;
    background-color: $bg-card;
    border: 1px solid $border-color;
    border-radius: 8px;
    padding: 0.625rem 2rem 0.625rem 0.875rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: $text-primary;
    cursor: pointer;
    transition: all 0.2s ease;

    &:focus {
      outline: none;
      border-color: $primary-brand;
      box-shadow: 0 0 0 3px rgba($primary-brand, 0.1);
    }
  }
}
  
  .table-wrapper {
    max-width: 1000px;
    margin: 0 auto;
    background-color: $bg-card;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);
    border: 1px solid $border-color;
    overflow: hidden;
  }
  
  // --- Responsive Table Architecture ---
  .responsive-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  
    th, td {
      padding: 1rem 1.5rem;
    }
  
    .text-right {
      text-align: right;
    }
  
    // Header Styles
    thead {
      background-color: #fafafa;
      border-bottom: 1px solid $border-color;
  
      th {
        font-size: 0.75rem;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.05em;
        color: $text-secondary;
      }
    }
  
    // Body Styles
    tbody {
      tr {
        border-bottom: 1px solid lighten($border-color, 4%);
        transition: background-color 0.2s ease;
  
        &:hover {
          background-color: #fcfcfd;
        }
        
        &:last-child {
          border-bottom: none;
        }
      }
    }
  
    // Component Typography Elements
    .user-name {
      font-weight: 600;
      color: $text-primary;
    }
  
    .numeric-val {
      font-variant-numeric: tabular-nums;
      font-weight: 500;
    }
  
    .highlight-cell {
      background-color: rgba($primary-brand-light, 0.4);
    }
  
    .total-val {
      color: #0033EA;
      font-weight: 700;
    }
  
    // Podiums & Rank Badges
    .rank-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      font-weight: 700;
      font-size: 0.875rem;
      background-color: $bg-main;
      color: $text-secondary;
    }
  
    // Dynamic row accents for podium metrics
    .row-rank-1 {
      .rank-badge { background-color: $gold-bg; color: $gold; }
    }
    .row-rank-2 {
      .rank-badge { background-color: $silver-bg; color: $silver; }
    }
    .row-rank-3 {
      .rank-badge { background-color: $bronze-bg; color: $bronze; }
    }
  }
  
  // --- Mobile Responsiveness via Flexbox Stacking ---
  @media (max-width: $breakpoint-md) {
    .table-wrapper {
      background: transparent;
      border: none;
      box-shadow: none;
    }
  
    .responsive-table {
      display: block;
  
      thead {
        display: none; // Completely hides headers visually while preserving markup layout
      }
  
      tbody {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
  
      tr {
        display: grid;
        grid-template-columns: 1fr 1fr;
        background-color: $bg-card;
        border: 1px solid $border-color;
        border-radius: 14px;
        padding: 1rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  
        &:hover {
          background-color: $bg-card;
        }
      }
  
      td {
        display: flex;
        flex-direction: column;
        padding: 0.5rem !important;
        text-align: left !important;
        
        // Inject the pseudo elements referencing the exact structural labels
        &::before {
          content: attr(data-label);
          font-size: 0.7rem;
          text-transform: uppercase;
          font-weight: 600;
          letter-spacing: 0.05em;
          color: $text-secondary;
          margin-bottom: 0.25rem;
        }
      }
  
      // Mobile layout transformations per component
      .col-rank {
        grid-column: 1;
        order: 1;
        .rank-badge { width: 1.75rem; height: 1.75rem; }
      }
  
      .col-user {
        grid-column: 1 / span 2;
        order: 2;
        border-bottom: 1px dashed $border-color;
        padding-bottom: 0.75rem !important;
        margin-bottom: 0.25rem;
        .user-name { font-size: 1.1rem; }
      }
  
      .col-points { grid-column: 1; order: 3; }
      .col-social { grid-column: 2; order: 4; }
  
      .col-total {
        grid-column: 1 / span 2;
        order: 5;
        background-color: $primary-brand-light;
        border-radius: 8px;
        padding: 0.75rem !important;
        margin-top: 0.5rem;
      }
    }
  }
  </style>
  